import { Environment, MySquid, onUserChange, onConfigChange, onEnvironmentChange, SocialConnect, User } from '@hub/shared'
import BoxReachComponent from '@src/components/box-reach-home/box-reach-home.component'
import CampaignsShortcuts from '@src/components/campaigns-shortcuts/campaigns-shortcuts.component'
import Header from '@src/components/header/header.component'
import InfluencersLife from '@src/components/influencers-life/influencers-life.component'
import PaymentShortcut from '@src/components/payment-shortcut/payment-shortcut.component'
import RegisterCompletenessComponent from '@src/components/register-completeness/register-completeness.component'
import SectionList from '@src/components/section-list/section-list.component'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { SubscriptionLike } from 'rxjs'

import CreatorsInsightsBanner from '@src/components/creators-insights/banner/banner-creators-insights.component'
import './home.page.scoped.scss'
import { showInsights } from '@src/utils/showInsights'

const HomePageComponent = () => {
  const onEnvironmentChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const onConfigChangeSubscription = useRef<SubscriptionLike | undefined | null>(undefined)
  const [config, setConfig] = useState<MySquid | null>(null)
  const [squidCommunityUrl, setSquidCommunityUrl] = useState<string>('')
  const [showNextPayments, setShowNextPayments] = useState<boolean>(true)
  const [isRegisterCompleteVisible, setIsRegisterCompleteVisible] = useState(false)
  const [isBoxReachVisible, setIsBoxReachVisible] = useState(true)
  const navigate = useNavigate()
  const { t } = useTranslation('homePage')
  // TODO: Validação Meta remover
  const [user, setUser] = useState<User | null>(null)

  useEffect(() => {
    onEnvironmentChangeSubscription.current = onEnvironmentChange.subscribe((environment: Environment) => {
      setSquidCommunityUrl(environment?.squidProducts?.vidaDeInfluencer)
    })

    return () => onEnvironmentChangeSubscription?.current?.unsubscribe()
  }, [])

  useEffect(() => {
    onConfigChangeSubscription.current = onConfigChange.subscribe((configChanged: MySquid | any) => {
      if (configChanged?._id) {
        setConfig(configChanged)
      }
    })
    return () => {
      onConfigChangeSubscription.current?.unsubscribe()
    }
  }, [onConfigChangeSubscription])

  const isBannerFullWidth = !isRegisterCompleteVisible && !isBoxReachVisible

  // TODO: Validação Meta remover
  useEffect(() => {
    const onUserChangeObservable: SubscriptionLike = onUserChange.subscribe((user: User) => {
      setUser(user)
    })
    return () => {
      onUserChangeObservable?.unsubscribe()
    }
  }, [])

  return (
    <div className="home-page">
      <Header />
      <section className="social-network-connect">
        <SocialConnect />
        <section className="section-insights">
          {/* TODO: Validação Meta remover */}
          {showInsights({ configs: config, user }) ? <CreatorsInsightsBanner className={isBannerFullWidth ? 'full-width' : ''} /> : null}
          <section
            className="tasks display-flex align-items-stretch justify-content-center"
            style={{ backgroundColor: 'var(--background_reset)' }}
          >
            <RegisterCompletenessComponent onVisibilityChange={setIsRegisterCompleteVisible} />
            {!isRegisterCompleteVisible && <BoxReachComponent onVisibilityChange={setIsBoxReachVisible} />}
          </section>
        </section>
      </section>
      <div className="light py-3 px-5" style={{ backgroundColor: 'var(--background_reset)' }}>
        <section className="section-list">
          <SectionList
            title={t('influencersLife.title')}
            labelButton={t('influencersLife.labelButton')}
            onClickButton={() => window.open(`${squidCommunityUrl}?utm_source=creatorshub`, '_blank')}
            show={!config?._id}
          >
            <InfluencersLife />
          </SectionList>
        </section>
        <section className="campaigns-shortcuts py-3">
          <CampaignsShortcuts />
        </section>
        <section className="next-payments-shortcuts py-3">
          <SectionList
            title={t('nextPayments.title')}
            labelButton={t('nextPayments.labelButton')}
            onClickButton={() => navigate('/payments/info')}
            show={showNextPayments}
          >
            <PaymentShortcut onSetShowNextPayments={(showNextPayments) => setShowNextPayments(showNextPayments)} disableTip />
          </SectionList>
        </section>
      </div>
    </div>
  )
}

export default HomePageComponent
